export function isNumber(value: unknown): value is number {
  return typeof value === 'number' && isFinite(value) && !isNaN(Number(value.toString()));
}

export function isNumberArray(item: unknown): item is number[] {
  return Array.isArray(item) && item.every((i) => isNumber(i));
}

export function separateThousands(value: number | null, sep = ' ', digits: number | null = null): string {
  if (!isNumber(value)) {
    return '-';
  }
  if (digits) {
    value = parseFloat(value.toFixed(digits));
  }

  if (value != null && !isNaN(value) && Number.isFinite(value)) {
    //https://stackoverflow.com/questions/16637051/adding-space-between-numbers
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }
  return '-';
}

export function hasMoreThanTwoDecimalPlaces(input: number): boolean {
  // Convert input to a string to handle both numbers and string inputs
  if (typeof input !== 'number') {
    return false;
  }
  const inputStr = input.toString();
  // Regular expression to check for more than two decimal places
  const regex = /\d+(\.\d{3,})?$/;
  return regex.test(inputStr);
}

/**
 * Calculates the average (arithmetic mean) of an array of numbers.
 */
export function getAverage(numbers: number[]): number {
  if (numbers.length === 0) return NaN; // Return NaN for an empty array to indicate no valid average

  const sum = numbers.reduce((acc, num) => acc + num, 0); // Sum up all numbers
  return sum / numbers.length; // Divide by the count of numbers
}

export function getPercentage(input: number | null, fractionDigits = 1): string {
  if (input === null || input === undefined) {
    return '';
  }
  if (!isNumber(input) || input < 0 || input > 1) {
    console.error(`invalid percentage value is provided: ${input}`);
    return '';
  }
  return (Math.round(input * 1000) / 10).toFixed(fractionDigits) + '%';
}
